import { Action } from '@anm/components/ActionsDropdown';
import AddToBrandAction from '@anm/components/dropdown-actions/AddToBrand';
import { getDropdownAction } from '@anm/helpers/dropdownActions';

import config from '../../../../config';

const { urls } = config();

type AddToBrandActionProps = {
  projectId: string;
  canEditBrand: boolean;
  isPublished: boolean;
  handler?: () => void;
  isNotStable?: boolean;
};

const useAddToBrandAction = ({ projectId, isPublished, canEditBrand, isNotStable, handler }: AddToBrandActionProps) => {
  const publishUrl = `${urls.editor}/#p=${projectId}&target=publish`;

  const action = getDropdownAction('onAddToBrand');

  const streamVideoAction: Action = {
    icon: action.icon,
    disabled: !canEditBrand || !isPublished || isNotStable,
    autoClose: false,
    renderComponent: () => (
      <AddToBrandAction {...{ action, isNotStable, isPublished, handler, canEditBrand, publishUrl }} />
    )
  };

  return streamVideoAction;
};

export default useAddToBrandAction;
